import { useTranslation } from "react-i18next";
import PrivacyPolicyEs from "../components/PrivacyPolicy/PrivacyPolicyEs";
import PrivacyPolicyEn from "../components/PrivacyPolicy/PrivacyPolicyEn";

export default function PrivacyPolicy() {
  const { i18n } = useTranslation();

  return (
    <div className="terms-policy">
      {i18n.language === "es" ? <PrivacyPolicyEs /> : <PrivacyPolicyEn />}
    </div>
  );
}
